<template>
  <div class="list-item e-list-wrapper  e-list-multi-line ">
    <div class="label">
      <span v-if="data.partText" class="e-list-item-header">{{data.partText}} {{data.partName}}</span>
      <span class="e-list-content">{{data.ecrNumber}} - {{ data.csText }}</span>
      <span v-if="data.version" class="e-list-content">{{data.version }} | {{data.snapshot}}</span>
    </div>
    <div class="remove-btn">
      <span class="remove-item-btn"><i class="fas fa-times"></i></span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
        data: {}
    }
  }
}
</script>

<style scoped>

div.list-item.e-list-wrapper {
  height: 85px;
  padding: 0 !important;
}

.label {
  display: inline-block;
  width: 90%;
  float: left;
  padding: 1.066em;
}

.remove-btn {
  padding: 0;
  margin: 0;
  /* padding-top: 14px; */
  width: 5%;
  float: right;
}

.remove-btn span {
  display: block;
  font-size: 18px;
  width:100%;
  height: 48px;
  margin:0;
  padding: 32px 10px 5px;
}

.remove-btn span:hover {
  background-color: lightgray;
}

</style>